import { LoginView } from '@/enums/LoginView';
import { ProvideEmailForm } from '@/components/Views/Login/ProvideEmailForm/ProvideEmailForm';
import { OnlyEmailPasswordLogin } from '@/components/Views/Login/OnlyEmailPasswordLogin/OnlyEmailPasswordLogin';
import { OnlySSOLogin } from '@/components/Views/Login/OnlySSOLogin/OnlySSOLogin';
import { SSOAndEmailPasswordLogin } from '@/components/Views/Login/SSOAndEmailPasswordLogin/SSOAndEmailPasswordLogin';
import { Title } from '@/components/Elements/Title/Title';
import { useTranslation } from 'react-i18next';
import styles from './login.module.scss';

type LoginProps = {
  email: string;
  submitting: boolean;
  view: LoginView;
  onEmailSubmit: (email: string) => void;
  handleEmailPasswordLogin: (email: string, password: string) => void;
  handleSSOLogin: () => void;
  restartSigninProcess: () => void;
};

export const Login = ({
  email,
  submitting,
  view,
  onEmailSubmit,
  handleEmailPasswordLogin,
  restartSigninProcess,
  handleSSOLogin,
}: LoginProps) => {
  const { t } = useTranslation();

  const renderForm = () => {
    switch (view) {
      case LoginView.PROVIDE_EMAIL:
        return (
          <ProvideEmailForm
            submitting={submitting}
            onEmailSubmit={onEmailSubmit}
          />
        );
      case LoginView.EMAIL_PASSWORD:
        return (
          <OnlyEmailPasswordLogin
            email={email}
            submitting={submitting}
            handleSignIn={handleEmailPasswordLogin}
            restartSigninProcess={restartSigninProcess}
          />
        );
      case LoginView.SSO:
        return (
          <OnlySSOLogin
            email={email}
            handleSignIn={handleSSOLogin}
            restartSigninProcess={restartSigninProcess}
          />
        );
      case LoginView.SSO_EMAIL_PASSWORD:
        return (
          <SSOAndEmailPasswordLogin
            email={email}
            submitting={submitting}
            handleEmailPasswordSignin={handleEmailPasswordLogin}
            handleSSOLogin={handleSSOLogin}
            restartSigninProcess={restartSigninProcess}
          />
        );
    }
  };

  return (
    <>
      <Title title={t('login.title')} className={styles.title} />
      {renderForm()}
    </>
  );
};
